import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HierarchyService } from '../services/hierarchy.service';

@Component({
  selector: '',
  template: '',
})
export class CountDetailsSearchHandler extends BaseSearchComponent<HierarchyService> implements OnInit {
  public searchName: string;
  public agentName: string;
  public fullPath;
  private pathSegments;
  public searchCriteriaData;
  public isAdvanceSearchRequired: boolean;
  schemeInfo: {
    schemeName: string;
    startDate: Date | null;
    endDate: Date | null;
  };

  constructor(
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    this.isAdvanceSearchRequired = false;
    this.searchName = 'SearchSubordinatesSchemeDetails';
    this.pathSegments = this.route.snapshot.url;
    this.fullPath = this.pathSegments.map((segment) => segment.path).join('/');

    this.searchCriteriaData = {
      'SubordinateSchemeDO.definition': this.pathSegments[2].path,
      'SubordinateSchemeDO.startDt': this.pathSegments[3].path,
      'SubordinateSchemeDO.endDt': this.pathSegments[4].path,
      'SubordinateSchemeDO.evaluationResult':
        this.pathSegments[0].path == 'qualified-subordinates-details' ? 'QUALIFIED' : 'UNQUALIFIED',
    };
  }

  ngOnInit() {
    super.ngOnInit();
    this.getSearchList();
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'TeamSchemeDetails',
        link: '/search-team-scheme-details',
      },
      {
        id:
          this.pathSegments[0].path == 'qualified-subordinates-details'
            ? 'qualifiedDetails'
            : 'notQualifiedDetails',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title =
      this.pathSegments[0].path == 'qualified-subordinates-details'
        ? this.settingService.getLabelValue('qualifiedDetails')
        : this.settingService.getLabelValue('notQualifiedDetails');
    return header;
  }

  getSearchList() {
    this.service
      .getSearchList('SearchSubordinatesSchemeDetails', true, this.searchCriteriaData)
      .subscribe((response: any) => {
        const resultData = response.data.searchResultData?.[0];
        const info = response.data.searchResultInfo;

        if (resultData && info) {
          const defIndex =
            (Object.values(info).find((x: any) => x.metadata === 'SubordinateSchemeDO.definition')?.['position'] ||
              0) - 1;
          const startDtIndex =
            (Object.values(info).find((x: any) => x.metadata === 'SubordinateSchemeDO.startDt')?.['position'] ||
              0) - 1;
          const endDtIndex =
            (Object.values(info).find((x: any) => x.metadata === 'SubordinateSchemeDO.endDt')?.['position'] || 0) -
            1;
          const rawStartDate = resultData[startDtIndex];
          const rawEndDate = resultData[endDtIndex];

          this.schemeInfo = {
            schemeName: resultData[defIndex],
            startDate: this.parseDate(rawStartDate),
            endDate: this.parseDate(rawEndDate),
          };
        }
      });
  }

  parseDate(input: string): Date | null {
    if (!input) return null;
    const parts = input.split('/');
    if (parts.length === 3) {
      const [day, month, year] = parts.map(Number);
      return new Date(year, month - 1, day);
    }
    return null;
  }
}
